import React, { useState } from "react";

// import JS files
import Header from "../shares/others/Header";
import MediaCard from "./MediaCard";

// import others files
import useFetch from "../../context/useFetch";

const Media = (props) => {
  const [lastMediaNews, setLastMediaNews] = useState();
  const [newsList, setNewsList] = useState([]);
  const getMultimediaListApi = useFetch({
    method: "get",
    url: "News_Service/get_multimedia_news",
    noHeader: true,
    trigger: true,
    argFunc: (res) => {
      setLastMediaNews(res[0]);
      let before = [];
      before = res.slice(1);
      setNewsList(before);
    },
  });

  console.log("amin", newsList);
  return (
    <>
      <div className="mt-8 md:mt-16">
        <Header header="چندرسانه‌ای" redirect_url="/media-list" />
        <div className=" grid md:grid-cols-2 gap-4">
          <MediaCard
            class="rounded-t-lg md:rounded-lg w-full h-48 md:h-[32rem]"
            id={lastMediaNews?.news}
            type={
              lastMediaNews?.type == "video"
                ? "ویدیو"
                : lastMediaNews?.type == "image"
                ? "گزارش تصویری"
                : "رادیو"
            }
            img={lastMediaNews?.cover_file}
            text={lastMediaNews?.news_detail?.header}
          />
          <div className=" grid md:grid-cols-2 gap-[1rem]">
            {newsList.map((it, ind) => {
              return [
                <MediaCard
                  class="rounded-t-lg md:rounded-lg  w-full h-48 md:h-[15.5rem]"
                  id={it.news}
                  type={
                    it.type == "video"
                      ? "ویدیو"
                      : it.type == "image"
                      ? "گزارش تصویری"
                      : "رادیو"
                  }
                  img={it.cover_file}
                  text={it.news_detail.header}
                />,
              ];
            })}
          </div>
        </div>
      </div>
    </>
  );
};

export default Media;
